module.exports = "https://dev.stanwinstonschool.com/theamazing.13cbfab2baf50fd01b3d3d7ac76cbded.jpg";